import React from 'react';

import { Type } from 'src/models/Sidekick/SidekickModuleSpec';
import ArrayControl from './ArrayControl';
import BoolControl from './BoolControl';
import InputControl from './InputControl';
import StringControl from './StringControl';
import TimestampControl from './TimestampControl';

const Controls = {
  [Type.array]: props => <ArrayControl {...props} />,
  [Type.string]: props => <StringControl {...props} />,
  [Type.number]: props => <InputControl {...props} />,
  [Type.currency]: props => <InputControl {...props} />,
  [Type.bool]: props => <BoolControl {...props} />,
  [Type.timestamp]: props => <TimestampControl {...props} />,
};

const getControlsFactory = (type: Type) => {
  if (!Controls[type]) {
    return null;
  }

  return Controls[type];
};

export default getControlsFactory;
